<template>
  <footer class="footer">
    <div class="container-fluid d-flex flex-wrap justify-content-between">
      <nav>
        <ul class="footer-menu">
          <li>
            <router-link :to="{ path: '/' }">Home</router-link>
          </li>
        </ul>
      </nav>
      <div class="copyright">
        &copy; {{ year }} by
        <a href="https://chris.jamieson.im" target="_blank">Chris Jamieson</a>
        at <a href="https://melior.im" target="_blank">Melior</a>.
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style></style>
